import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ spacing }) => ({
    ui_table: {
        marginBottom: ({ gutterBottom }) => (gutterBottom ? spacing(2) : 0),
    },
}));
//# sourceMappingURL=ui_table.css.js.map